import React from "react";
import { TournamentResult, GeneralRanking } from "../../types"; // importa i tuoi tipi
import { userLabel } from "../../api"

type RankingTableProps =
  | { type: "tournament"; data: TournamentResult[] }
  | { type: "general"; data: GeneralRanking[] };

const podiumEmojis = ["🥇", "🥈", "🥉"];

export const RankingTable: React.FC<RankingTableProps> = ({ type, data }) => {
  // definizione colonne a seconda del tipo
  const headers =
    type === "tournament"
      ? [
          { label: "Posizione", short: "#", key: "position", class: "text-center w-[40px]" },
          { label: "Giocatore", short: "Giocatore", key: "user", class: "text-left" },
          { label: "Punti", short: "Pt", key: "score", class: "text-right" },
        ]
      : [
          { label: "Posizione", short: "#", key: "position", class: "text-center w-[40px]" },
          { label: "Giocatore", short: "Giocatore", key: "user", class: "text-left" },
          { label: "Giocati", short: "G", key: "tournaments_played", class: "text-right" },
          { label: "Vinti", short: "V", key: "tournaments_won", class: "text-right" },
          { label: "Totale", short: "Pt", key: "total_score", class: "text-right" },
        ];
  const sortedData = [...data].sort((a, b) => a.position - b.position);

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm border-collapse">
        <thead>
          <tr className="bg-gray-200 text-gray-700">
            {headers.map((h) => (
              <th
                key={h.key}
                className={`px-2 py-2 sm:px-4 sm:py-3 ${h?.class}`}
              >
                <span className="hidden sm:inline">{h.label}</span>
                <span className="sm:hidden">{h.short}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedData.map((row, _) => {
            const isPodium = row.position <= 3;
            const score = type === "general" ? (row as GeneralRanking).total_score : (row as TournamentResult).score;
            return (
              <tr
                key={row.id}
                className={`border-b ${
                  (isPodium && score > 0) ? "bg-yellow-100" : "bg-white"
                }`}
              >
                <td className={`px-2 py-2 sm:px-4 sm:py-3 ${headers[0]?.class}`}>
                  {score > 0 ? (
                    row.position > 3 ? row.position : podiumEmojis[row.position - 1]
                  ) : "-"}
                </td>
                <td className={`px-2 py-2 sm:px-4 sm:py-3 max-w-[120px] truncate ${headers[1]?.class}`}>
                  <div className="flex items-center gap-1">
                    {userLabel(row.user)}
                  </div>
                </td>
                {type === "tournament" && (
                  <td className={`px-2 py-2 sm:px-4 sm:py-3 ${headers[2]?.class}`}>
                    {(row as TournamentResult).score}
                  </td>
                )}
                {type === "general" && (
                  <>
                    <td className={`px-2 py-2 sm:px-4 sm:py-3 ${headers[2]?.class}`}>
                      {(row as GeneralRanking).tournaments_played}
                    </td>
                    <td className={`px-2 py-2 sm:px-4 sm:py-3 ${headers[3]?.class}`}>
                      {(row as GeneralRanking).tournaments_won}
                    </td>
                    <td className={`px-2 py-2 sm:px-4 sm:py-3 ${headers[4]?.class}`}>
                      {(row as GeneralRanking).total_score}
                    </td>
                  </>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
